export default __webpack_public_path__ + "static/media/homepage.d5a7a636.jpg";